/***
 * Created on 2023/8/22
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useRef, useState} from 'react';
import ModalDialog from "../../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import PasswordInput from "../../../common/form/password_input";
import md5 from "blueimp-md5";
import {useCaptcha} from "../../../../hook/captcha";
import {useMutation} from "@tanstack/react-query";
import {apiPost} from "../../../../service/api";
import {getErrorMessage} from 'common/ServiceCommon';


function VerifyPassword({dispatch, state, callback, ..._props}) {
    const { t } = useTranslation();
    const [inputValues, setInputValues] = useState({
        password: ''
    });
    const [passInputValid, setPassInputValid] = useState(false);
    const modalRef = useRef();

    const verifyMutation = useMutation({
        mutationFn: async (data) => await apiPost(`/ajax/authenticate_user_password`, data),
        onSuccess: async data => {
            if (callback && typeof callback === 'function') {
                await callback();
            }
            else {
                dispatch({type: state.openAfterPassVerified, value: true})
            }
        },
        onError: (error, variables, context) => {
            console.error(error);
            // modalRef.current.alert('error', true, getErrorMessage(t, error.cause?.code));
            // modalRef.current.disableSubmitButton(false);
        }
    });

    const onSubmit = async () => {
        const data = {
            ...inputValues,
            password: md5(inputValues.password)
        }
        await verifyMutation.mutateAsync(data);
    }

    const onChange = (e, callback, name=null, value=null) => {
        if (callback && typeof callback === 'function') {
            callback(e);
        }
        const _name = name ? name : e.target.name;
        const _value = value ? value: e.target.value;
        setInputValues(prev => {
            return {
                ...prev,
                [_name]: _value
            }
        })

        if (_value && _value.length > 0) {
            modalRef.current.disableSubmitButton(false);
        }
        else {
            modalRef.current.disableSubmitButton(true);
        }
    }

    const {Captcha, hasCaptcha, captchaValue, captchaError} = useCaptcha(onChange);

    return (
        <ModalDialog {..._props} title={t('@Verify Password@')} submitText={t('@Edit@')} initDisableSubmit={true} submitAction={onSubmit} ref={modalRef}>
            <div className="dialog-content">
                <p>
                    {t('@To verify that you wish to edit 2-Step Verification either moving to a new device or changing to a new phone number to receive SMS verification, enter the verification code sent to your phone number as a SMS, then click "Edit".@')}
                </p>
                <br/>
                <PasswordInput
                    placeholder={t('@Password@')}
                    value={inputValues.password}
                    name="password"
                    onChange={onChange}
                    status={setPassInputValid}
                    compType="dialog"
                    required={true}/>

                { hasCaptcha && Captcha }
            </div>
        </ModalDialog>
    );
}

export default VerifyPassword;